<template>
    <div>
        <barraprincipaladmin @abrir="mtMenuVisible"> </barraprincipaladmin>
        <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>
         <!-- //TODO agragar numero de tarjeta -->
        <v-container fluid>

            <div class="claro elevation-5">
                <v-row dense>     
                    <v-col cols="12" md="12" class="d-flex align-center px-4">
                        <h2 class="primary--text">Contratos.</h2>                    
                    </v-col>                    
                </v-row>
            </div>      

            <br>  

            <v-row>
                <v-col cols="12" md="12" class="d-flex justify-end">
                    <v-btn dense color="primary" @click="abrirDialogoContrato()" dark> <v-icon>mdi-plus</v-icon> Crear</v-btn>
                </v-col>
            </v-row>            

            <v-row>
                <v-col cols="12" md="12">
                    <div class="mx-0">
                        <v-data-table
                            dense
                            :headers="tabla_encabezado"
                            :items="contratos"
                            :item-class="color_fondo"
                            :items-per-page="-1"
                            class="elevation-1"
                            mobile-breakpoint="100"
                            multi-sort
                            :search="busqueda"
                            loading-text="Consultando información..."
                            :loading="cargando"
                            no-data-text="No se encontró información."
                            locale="es-MX"
                            :footer-props="{
                                'items-per-page-text':'Elementos por página',
                                'items-per-page-all-text': 'Todos',
                                'show-current-page':true,
                                'show-first-last-page': true,
                                'page-text':page_text
                            }"
                            @pagination="texto_paginacion"
                        >

                        <!-- Acciones -->
                        <template v-slot:item.acciones="{ item }">
                            <div class="d-flex justify-end">                                    
                                <v-btn title="Eliminar contrato" v-if="item.estatus == 1"  icon color="error" @click="eliminarContrato(item)"><v-icon>mdi-delete-circle-outline</v-icon></v-btn>
                                <v-btn title="Editar contrato" v-if="item.estatus < 2" icon color="primary" @click="getDetalleContrato(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                                <v-btn title="Imprimir contrato" icon color="success" @click="imprimirContrato(item.ccontrato, item.estatus)"><v-icon>mdi-printer-outline</v-icon></v-btn>
                            </div>
                        </template>

                        </v-data-table>
                    </div>
                </v-col>
            </v-row>

                <v-dialog v-if="dlgcontrato" v-model="dlgcontrato" max-width="1500" persistent fullscreen transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar dark color="primary" dense>
                            Contrato
                            <v-spacer></v-spacer>
                            <v-icon @click="cerrarDialogoContrato()" >mdi-close</v-icon>
                        </v-toolbar>

                        <v-card-text class="mt-3">

                            <v-row class="d-flex justify-left" dense>
                                <v-col cols="12" sm="3">
                                    <v-text-field autofocus class="accent" v-model="folio" label='Folio' hide-details outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select class="accent" :disabled="select_servicio" @change="getDetalleServicio(servicio_seleccionado)" label="Servicio requerido" v-model="servicio_seleccionado" :items="servicios_requeridos" dense outlined hide-details></v-select>
                                </v-col>
                            </v-row>

                           <v-row class="d-flex justify-left" dense>
                            </v-row>
                            <div class="contrato">

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>BASES DE ACUERDO Y/O COORDINACIÓN DE PRESTACIÓN DE SERVICIOS PROFESIONALES BAJO EL RÉGIMEN DE 
                                            <span v-if="psp_seleccionado.tipo_contrato == 'honorarios'">HONORARIOS </span>
                                            <span v-if="psp_seleccionado.tipo_contrato == 'asimilados'">COMPENSACIONES POR SERVICIOS EVENTUALES </span>
                                            
                                            QUE CELEBRAN POR UNA PARTE, EL Instituto Tecnológico de Parral, A QUIEN EN LO SUCESIVO SE </div>
                                        <div class="d-flex">
                                            LE DENOMINARÁ  "EL INSTITUTO", REPRESENTADO EN ESTE ACTO POR
                                            <v-text-field class="nombrepersonal mx-2 accent" v-model="representante" dense hide-details></v-text-field>,
                                            EN SU CARÁCTER DE DIRECTOR(A) Y POR LA</div>
                                        <div class="d-flex">
                                            OTRA,
                                            <v-select label="Prestador de servicios" class="nombrepersonal mx-2 accent" v-model="psp_seleccionado" :items="prestadores_de_servicios" outlined dense hide-details></v-select>,
                                            A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ COMO "EL PRESTADOR DE SERVICIOS", Y
                                        </div>
                                        CUANDO ACTÚEN EN FORMA CONJUNTA A AMBOS ENTES SE LE DENOMINARÁ A LO LARGO DEL CONTENIDO
                                        DE ESTE TEXTO, COMO "LAS PARTES", ACUERDO QUE SE SUJETARÁ AL TENOR DE LAS DECLARACIONES Y
                                        CLÁUSULAS SIGUIENTES:
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <p>
                                            <b>D E C L A R A C I O N E S</b>
                                        </p>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center" dense>
                                    <v-col cols="12">
                                        <p>
                                            1.- Declara "EL INSTITUTO" por conducto de su director(a) y bajo protesta de decir verdad:
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <p>
                                            1.1.- Que es una Institución de Educación Superior Tecnológica adscrita al Tecnológico Nacional de México, en lo
                                            sucesivo "EL TECNOLÓGICO", Órgano Administrativo Desconcentrado de la Secretaría de Educación Pública, con
                                            autonomía técnica, académica y de gestión, de conformidad con el artículo 1o. del Decreto de creación publicado
                                            en el Diario Oficial de la Federación, el día 23 de julio de 2014.
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <p>
                                            1.2.- Que de conformidad con el artículo 2o. del Decreto previamente referido, tiene como parte de su objeto, entre otros:
                                        </p>
                                    </v-col>

                                    <v-col cols="11">
                                        <p>
                                            I.- Prestar, desarrollar, coordinar y orientar servicios de educación superior tecnológica en los niveles de
                                                licenciatura y posgrado, en las modalidades escolarizada, no escolarizada a distancia y mixta; así como de
                                                educación continua y otras formas de educación que determine "EL TECNOLOGÍCO", con sujeción a los
                                                principios de laicidad, gratuidad y de conformidad con los fines y criterios establecidos en el artículo 3o. de la
                                                Constitución Política de los Estados Unidos Mexicanos;
                                        </p>
                                    </v-col>

                                    <v-col cols="11">
                                        <p>
                                            II.- Formar profesionales e investigadores aptos para la aplicación y generación de conocimientos que les
                                                proporcionen las habilidades para la solución de problemas, con pensamiento crítico, sentido ético, actitudes
                                                emprendedoras, de innovación y capacidad creativa para la incorporación de los avances científicos y
                                                tecnológicos que contribuyan al desarrollo nacional y regional;
                                        </p>
                                    </v-col>


                                    <v-col cols="11">
                                        <p>
                                            III.- Diseñar y establecer programas para atender el modelo de educación dual que propicie el aprendizaje de los
                                                alumnos, por la vía de su incorporación a la vida laboral y a los procesos productivos de las empresas, bajo la
                                                supervisión académica de "EL TECNOLÓGICO", en coordinación con las propias empresas;
                                        </p>
                                    </v-col>

                                    <v-col cols="11">
                                        <p>

                                            IV.- Desarrollar e impulsar la investigación aplicada, científica y tecnológica que se traduzca en aportaciones
                                                concretas para mantener los planes y programas de estudio, actualizados y pertinentes, así como para mejorar
                                                la competitividad y la innovación de los sectores productivos y de servicios y elevar la calidad de vida de la
                                                sociedad.
                                        </p>
                                    </v-col >
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            1.3.- Que de conformidad con el artículo 7o. del Acuerdo 93,
                                            <v-text-field class="nombrepersonal mx-1 accent" v-model='representante'  dense  hide-details></v-text-field>
                                            actualmente desempeña el cargo de Director(a) de "EL INSTITUTO", 
                                        </div>
                                        <div class="d-flex">
                                            según consta en su nombramiento
                                        </div>
                                        <div class="d-flex">
                                            contenido en el oficio número
                                            <v-text-field class="oficio mx-2 accent" v-model='nombramiento_oficios' dense   hide-details></v-text-field>
                                            de fecha
                                            <v-text-field class="fecha mx-2 accent" v-model='nombramiento_fecha' dense   hide-details></v-text-field>,
                                            expedido a su favor por el entonces
                                            <v-text-field class="nombrepersonal mx-2 accent" v-model="nombramiento_emisor" dense   hide-details></v-text-field>,
                                        </div>
                                        <div class="d-flex">
                                            teniendo las atribuciones para proponer la contratación del personal de "EL INSTITUTO".
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            1.4.- Que para cumplir con su objeto y fines, además de sus programas y presupuestos aprobados, realiza actividades
                                            concretas, mediante la celebración de convenios y acuerdos con los sectores público, social y privado. De acuerdo
                                            con sus necesidades, requiere temporalmente contar con los servicios de una persona física con conocimientos en:
                                        </div>
                                        <div class="d-flex">
                                            <v-text-field class="accent" disabled v-if="servicio_detalle" v-model="servicio_detalle.pspconocimientos" dense hide-details></v-text-field>,
                                        </div>
                                        <div class="d-flex">
                                            por lo que ha determinado llevar a cabo la contratación de "EL PRESTADOR DE SERVICIOS".
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            1.5.- Que cuenta con recursos percibidos mediante ingresos propios, para cubrir las erogaciones que se generen con
                                            motivo de la celebración del presente acuerdo a través del Capítulo 1000 SERVICIOS PERSONALES,
                                        </div>
                                        <div class="d-flex">
                                            Partida
                                            <v-select class="partida accent mx-2" hide-details label="Partida" :items="item_partida" outlined dense v-model="partida" ></v-select>
                                            <!-- <v-text-field class="partida mx-2 accent" v-model="partida" dense hide-details></v-text-field>, -->
                                            que a la letra dice:
                                            "<v-text-field disabled class="" v-model="partida.descripcion" dense hide-details></v-text-field>",
                                        </div>
                                        <div class="d-flex">
                                            para cubrir el importe de los honorarios de "EL PRESTADOR DE SERVICIOS".
                                        </div>

                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            1.6.- Que el presente no contraviene lo expresado en el artículo 131 del Reglamento de la Ley Federal de Presupuesto y
                                            Responsabilidad Hacendaria, y cumple con el procedimiento de Adjudicación Directa previsto en los Artículo 41
                                            fracción XIV y 42 de la Ley de Adquisiciones, Arrendamientos y Servicios del Sector Público, al ser realizada por
                                            una sola persona física, sin requerir de más de un ayudante o técnico, así como por no sobrepasar el monto de
                                        </div>
                                        <div class="d-flex">
                                            adjudicación previsto en la Circular numero
                                            <v-text-field class="circular mx-2 accent" v-model="circular_adjudicacion_folio" dense   hide-details></v-text-field>, del
                                            <v-text-field class="fecha mx-2 accent" v-model="circular_adjudicacion_fecha" dense   hide-details></v-text-field>,
                                            emitida por el Director General del Tecnológico
                                        </div>
                                        <div class="d-flex">
                                            Nacional de México, mediante la cual se informó de los montos para las adquisiciones de bienes y servicios con
                                            cargo a ingresos propios, así como el artículo 100 de la Ley del Impuesto Sobre la Renta.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            1.7.- Que para los efectos del presente acuerdo señala como domicilio, el ubicado en:
                                            <v-text-field class="ml-2 accent" v-model='direccion_instituto'  dense hide-details></v-text-field>.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            1.8.- Que cuenta con la capacidad para realizar las retenciones que por motivo del Impuesto Sobre la Renta e Impuesto
                                            al Valor Agregado sean procedente, a fin de enterarlo a la autoridad competente.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            1.9.- Que, a través del Servicio de Administración Tributaria, Órgano Desconcentrado de la Secretaría de Hacienda y
                                            Crédito Público, obtiene el Registro Federal de Contribuyentes número TNM140723GFA, con razón social
                                            Tecnológico Nacional de México / <b>Instituto Tecnológico de Parral</b>
                                            con domicilio fiscal en Av. Universidad numero 1200, Quinto Piso
                                            Colonia Xoco, Benito Juárez, Ciudad de México, CP. 03330.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            1.10.- Realizó la verificación en el Sistema de Registro de Servidores Públicos Sancionados, a efecto de constatar que
                                            "EL PRESTADOR DE SERVICIOS" no se encuentra impedido por disposición legal o inhabilitado por resolución de
                                            autoridad competente para los fines del presente acuerdo, de conformidad con el artículo 59 de la Ley General de
                                            Responsabilidades Administrativas.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            1.11.- "EL INSTITUTO" manifiesta que las actividades que el "EL PRESTADOR DE SERVICIOS" realice conforme sus
                                            conocimientos experiencia, no estarán a las instrucciones de "EL INSTITUTO", en cuanto a la forma de desarrollar
                                            dichas actividades. Asimismo, éstas no serán iguales o equivalentes a las funciones conferidas a los servidores
                                            públicos con plaza presupuestaria y, no se cuenta con servidores públicos que prestan los servicios motivo de la
                                            contratación.
                                        </div>
                                    </v-col>

                                    <v-col cols="12">
                                        <div>
                                            2.- Declara "EL PRESTADOR DE SERVICIOS":
                                        </div>
                                    </v-col>

                                    <v-col cols="12">
                                        <div>
                                            2.1.- Que es una persona física, mayor de edad, en pleno uso y goce de las facultades que le otorga la ley, que cuenta
                                            con los conocimientos y dedicada al ejercicio de su profesión, y en su caso, con la experiencia necesaria para
                                            prestar el servicio requerido por "EL INSTITUTO".
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            2.2.- Que ha obtenido del Servicio de Administración Tributaria, Órgano Desconcentrado de la Secretaría de Hacienda y
                                        </div>
                                        <div class="d-flex">
                                            Crédito Público, el Registro Federal de Contribuyentes numero
                                            <v-text-field class="rfc ml-2 accent" v-model="psp_rfc" dense hide-details disabled></v-text-field>.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            2.3.- Que su Clave Única de Registro de Población es
                                            <v-text-field class="rfc ml-2 accent" v-model="psp_curp" dense hide-details disabled></v-text-field>.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            2.4.- Que sus datos bancarios para realizar depósitos por la prestación de sus servicios son:
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div class="d-flex">
                                            Banco:
                                            <v-text-field class="nombrepersonal ml-2 accent" v-model="psp_banco" dense hide-details disabled></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div class="d-flex">
                                            Sucursal:
                                            <v-text-field class="nombrepersonal ml-2 accent" v-model="psp_sucursal" dense hide-details disabled></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div class="d-flex">
                                            Número de Cuenta:
                                            <v-text-field class="nombrepersonal ml-2 accent" v-model="psp_cuenta" dense   hide-details disabled></v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div class="d-flex">
                                            CLABE Interbancaria:
                                            <v-text-field class="nombrepersonal ml-2 accent" v-model="psp_clabe" dense   hide-details disabled></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            2.5.- Estar interesado en prestar sus servicios en el periodo comprendido del
                                            <v-text-field disabled class="accent fecha ml-2" v-if="servicio_detalle != null" v-model="servicio_detalle.actividades[0].periodo" dense hide-details></v-text-field>.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            2.6.- Que cuenta con los conocimientos y conoce plenamente las características y necesidades de los servicios materia
                                            del presente acuerdo, así como, que ha considerado todos los factores que intervienen para desarrollar
                                            eficazmente las actividades que desempeñará.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            2.7.- Que manifiesta, bajo protesta de decir verdad, que no se encuentra inhabilitado para el desempeño de un empleo,
                                            cargo o comisión en la Administración Pública Federal, Estatal o Municipal, así como, que a la suscripción del
                                            presente documento no está prestando servicios profesionales por honorarios en las mismas y/o en distinta
                                            dependencia o entidad de la Administración Pública Federal, Estatal o Municipal, en la Procuraduría General de la
                                            República, en un Tribunal Administrativo o en la Presidencia de la República; que no interrumpe, afecta o
                                            suspende, en su caso, las funciones o actividades que desempeñare como servidor público, en la misma y/o en
                                            distinta dependencia o entidad de la Administración Pública Federal, Local o Municipal, en la Procuraduría General
                                            de la República, en un Tribunal Administrativo o en la Presidencia de la República y que a su vez afectaren el
                                            objeto del presente instrumento. Así mismo, que no es parte en un juicio del orden civil, mercantil o laboral en
                                            contra de alguna de las referidas instituciones públicas; y que no se encuentra en algún otro supuesto o situación
                                            que pudiera generar conflicto de intereses para prestar los servicios profesionales objeto del presente acuerdo.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            2.8.- Asimismo manifiesta que no existe interés personal, familiar o de negocios, ni parentesco consanguíneo o por
                                            afinidad hasta cuarto grado, que los una, y que se vean imposibilitados para la celebración del presente acuerdo;
                                            asimismo, establecen que tampoco son parientes civiles, ni existe beneficio para terceros con los que tenga
                                            relaciones profesionales, laborales o de negocios, o para socios o sociedades derivado de la prestación de
                                            servicios.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            2.9.- Que sus servicios personales independientes, no los presta únicamente a "EL INSTITUTO", sino a toda persona
                                            física o jurídicas que solicite la prestación de servicios profesionales independientes, que no es su única ni su
                                            principal fuente de subsistencia, pues percibe ingresos de otras entidades económicas.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            2.10.- Que, para los efectos de este acuerdo, deciden acogerse a lo establecido en el Capitulo II, Sección I, Articulo. 100,
                                            fracción II, de la Ley del Impuesto Sobre la Renta, "EL PRESTADOR DE SERVICIOS" y "EL INSTITUTO",
                                            conforme al tabulador vigente del Instituto/Centro.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            2.11.- Que es de nacionalidad MEXICANA y para los efectos del presente acuerdo, señala como su domicilio el ubicado en:
                                            <v-text-field class="ml-2 accent" v-model="psp_direccion" dense hide-details></v-text-field>.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            3.- Declaran "LAS PARTES":
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            3.1.- Se reconocen mutuamente la personalidad con que se ostentan y el alcance de las obligaciones que contraen, por
                                            lo que convienen en celebrar el presente instrumento, para lo cual se sujetan a las siguientes:
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            <b> C L Á U S U L A S</b>
                                        </div>
                                    </v-col>
                                </v-row>


                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            PRIMERA.- OBJETO: El presente acuerdo tiene por objeto sentar las bases sobre las cuales "EL PRESTADOR DE
                                        </div>
                                        <div class="d-flex">
                                            SERVICIOS": se obliga a prestar los servicios profesionales independientes para realizar las actividades de:
                                        </div>                                        
                                    </v-col>
                                    <v-col cols="11">
                                        <div v-if="servicio_detalle != null">
                                            <div v-for="(act, index) in servicio_detalle.actividades" :key="index">
                                                {{act.actividad}}
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            SEGUNDA.- OBLIGACIONES: Para la prestación de las actividades, trabajo o servicios a que hace referencia la cláusula
                                            anterior, "EL PRESTADOR DE SERVICIOS", se compromete a utilizar todos sus conocimientos técnicos, pericia y mayor
                                            diligencia, obligándose además a:
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="11">
                                        <div class="d-flex">
                                            a).- Realizar con eficacia y oportunidad las actividades profesionales derivadas del servicio de
                                            <v-text-field disabled class="accent ml-2" v-if="servicio_detalle != null" v-model="servicio_detalle.descripcion" dense hide-details></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="11">
                                        <div class="d-flex">
                                            b).- Presentar a "EL INSTITUTO", los informes de las actividades que realice durante la vigencia del presente
                                            acuerdo, así como, proporcionar cualquier dato o documento relativo a sus servicios profesionales.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            TERCERA.- DE LOS SERVICIOS: Los servicios estipulados en la cláusula primera, así como, las actividades previstas en
                                            la cláusula anterior, tendrán las siguientes caracteristicas:
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex justify-center">
                                            <table border="1px" width="85%" v-if="servicio_detalle != null">
                                                <tr>
                                                    <td>Area</td>
                                                    <td>Periodo</td>
                                                    <td>Dias</td>
                                                    <td>Horario</td>
                                                    <td>Horas</td>
                                                </tr>                                                
                                                <tr v-for="(act, key) in servicio_detalle.actividades" :key="key">
                                                    <td>{{act.area}} {{act.actividad}}</td>
                                                    <td><v-text-field disabled v-model="act.periodo" outlined dense   hide-details></v-text-field></td>
                                                    <td><v-text-field disabled v-model="act.dias" outlined dense   hide-details></v-text-field></td>
                                                    <td><v-text-field disabled v-model="act.horario" outlined dense   hide-details></v-text-field></td>
                                                    <td><v-text-field disabled v-model="act.horas" outlined dense   hide-details></v-text-field></td>
                                                </tr>                                                
                                            </table>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            Sin derecho a prorrogarse o/a extenderse, en virtud de que "EL INSTITUTO" al estar adscrito al Tecnológico Nacional de
                                            México, Órgano Administrativo Desconcentrado de la Secretaría de Educación
                                        </div>
                                        <div class="d-flex">
                                            Pública cuya operación y funcionamiento es financiada con dinero público, de conformidad con el Presupuesto de Egresos para el ejercicio fiscal
                                            <v-text-field class="mx-2 anio accent" v-model="ejercicio_fiscal" dense hide-details></v-text-field>
                                            por lo que, de prorrogarse,
                                        </div>
                                        <div>
                                            se causaría una afectación el presupuesto en que se le asignan los fondos para su funcionamiento y operación de éstos.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            CUARTA.- IMPORTE DEL ACUERDO: "EL INSTITUTO" se obliga a pagar a "EL PRESTADOR DE SERVICIOS" por
                                            concepto del servicio especificado en la Cláusula Primera, 
                                        </div>
                                        <div class="d-flex">
                                            la cantidad de $ (
                                            <v-text-field class="anio accent" v-model="montotal" dense hide-details></v-text-field>
                                            )
                                        </div>
                                        <div v-if="this.psp_tipo_contrato =='honorarios'">
                                            con IVA incluido, este monto es el pago de las actividades y/o funciones indicadas, mismo que será entregado a "EL PRESTADOR DE SERVICIOS", quien
                                            estará obligado a emitir su comprobante fiscal digital por internet (CFDI) correspondiente a "EL INSTITUTO".
                                        </div>
                                        <div v-if="this.psp_tipo_contrato =='asimilados'">
                                            menos retenciones, este monto es el pago de las actividades y/o funciones indicadas, mismo que será entregado a "EL PRESTADOR DE SERVICIOS".
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            Asimismo "EL INSTITUTO" se compromete que, para cubrir el pago convenido, "EL PRESTADOR DE SERVICIOS"
                                            deberá cumplir con lo estipulado en la cláusula tercera de este acuerdo y presentar la siguiente documentación en un
                                            plazo no mayor a 5 días naturales al término de la vigencia de cada periodo del presente acuerdo:
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            En caso de detectarse que "EL PRESTADOR DE SERVICIOS" desempeñe algún empleo, cargo o comisión en el servicio
                                            público y que este tenga un empalme de horas, respecto a lo declarado en el numeral 2.7 del apartado de
                                            DECLARACIONES del presente instrumento jurídico, "EL PRESTADOR DE SERVICIOS" está de acuerdo que el "EL
                                            INSTITUTO" realice el descuento proporcional a las horas en la intersección de los horarios de labores entre este
                                            instrumento jurídico y la plaza federal del "EL PRESTADOR DE SERVICIOS".
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            En caso de que "EL PRESTADOR DE SERVICIOS" no cumpla con alguna de las actividades y/o entregables referidos en
                                            la Cláusula Primera del presente instrumento, se descontará la parte proporcional al pago por la prestación del servicio
                                            señalado en la Cláusula Cuarta.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            "EL PRESTADOR DE SERVICIOS" se compromete a brindar los servicios señalados en la Cláusula Segunda de la
                                            presente Base, de manera personal por lo que será el único responsable de la ejecución de los servicios cuando no se
                                            ajusten a los términos y condiciones de este acuerdo.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            QUINTA.- "EL PRESTADOR DE SERVICIOS" se obliga a proporcionar los servicios bajo las más estrictas reglas de
                                            confidencialidad y secreto profesional, en este sentido, cualquier información o documentación que "EL PRESTADOR DE
                                            SERVICIOS" conserve como parte de sus archivos a la conclusión de los servicios pasará a ser propiedad de "EL
                                            INSTITUTO". Asimismo, "EL PRESTADOR DE SERVICIOS" se obliga a no divulgar los informes, datos y resultados
                                            obtenidos de los servicios prestados.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            SEXTA.- FORMA DE PAGO: "EL INSTITUTO" se obliga a pagar la cantidad correspondiente a "EL PRESTADOR DE
                                            SERVICIOS" de acuerdo a lo estipulado en la cláusula cuarta, una vez que "EL PRESTADOR DE SERVICIOS" haya dado
                                            cumplimiento a todas y cada una de las obligaciones precisadas en la cláusula segunda de este acuerdo.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            SÉPTIMA.- El "EL INSTITUTO" no quiere ni reconoce obligación alguna de carácter laboral, a favor de el "EL
                                            PRESTADOR DE SERVICIOS" en virtud de no ser aplicables a la relación contractual que consta en este instrumento, los
                                            artículos 1º y 8º de la Ley Federal del Trabajo y 2º y 6º de la Ley Federal de los Trabajadores al Servicio del Estado,
                                            Reglamentaria del Apartado B) del Artículo 123 Constitucional, el presente acuerdo se encuentra sujeto a legislación civil,
                                            por lo que el "PRESTADOR DEL SERVICIO" no podrá ser considerado como trabajador para los efectos legales, ni para
                                            obtener prestaciones establecidas en la Ley del Instituto de Seguridad y Servicios Sociales de los Trabajadores del Estado
                                            de acuerdo con lo dispuesto por los artículos 3º y 4º, o bien, los correspondiente a la Ley del Seguro Social en su artículo
                                            11.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            "EL PRESTADOR DE SERVICIOS" acuerda no identificarse, ni ostentarse como trabajador de "EL INSTITUTO" por
                                            ningún medio ni bajo ninguna circunstancia. La contravención a esta cláusula, será motivo de recisión del presente.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            Con base en lo anterior el "EL PRESTADOR DE SERVICIOS", manifiesta expresamente que en materia laboral no se
                                            reservará acción legal en contra de "EL INSTITUTO", ni interpondrá ante el Tribunal Federal de Conciliación y Arbitraje, ni
                                            ante la Junta Local de Conciliación y Arbitraje en el Estado de Chihuahua, ni cualquier Junta Local en otra entidad, demanda
                                            para acreditar ninguna relación laboral ni mucho menos prestación alguna.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            "EL PRESTADOR DE SERVICIOS" se obliga a responder de cualquier daño o perjuicio causado a los bienes o personal
                                            adscritos a "EL INSTITUTO" o a los bienes y al personal de terceros, cuando estos deriven de su negligencia, culpa, dolo
                                            o mala fe de "EL PRESTADOR DE SERVICIOS" o del personal que contrate en el desempeño de los servicios objeto del
                                            presente instrumento.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            OCTAVA.- LUGAR DE LOS SERVICIOS: Acuerdan "LAS PARTES" que el servicio a que se refiere la cláusula segunda
                                            del presente acuerdo, se prestará en las instalaciones de "EL INSTITUTO",
                                        </div>
                                        <div class="d-flex">
                                            ubicado en
                                            <v-text-field class="ml-2 accent" v-model="direccion_prestacion_servicio" dense   hide-details></v-text-field>.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            NOVENA.- DE LA CONTRAPRESTACIÓN: conviene en que la cantidad pactada en la cláusula Cuarta es fija, y "EL
                                            INSTITUTO" no pagará ninguna cantidad adicional por los servicios personales independientes contratados.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            DÉCIMA PRIMERA.- SUPERVISIÓN: "EL PRESTADOR DE SERVICIOS" no estará sujeto a subordinación, ni
                                            dependencia en cuanto a sus servicios, pero deberá reportar periódicamente
                                        </div>
                                        <div class="d-flex">
                                            a "EL INSTITUTO" a través del
                                            <v-text-field v-model="supervision" class="mx-2 accent" dense hide-details></v-text-field>, que para el efecto designe "EL INSTITUTO", el resultado de su trabajo,
                                            gestiones y acciones sobre los servicios contratados,
                                        </div>
                                        <div>
                                            en la forma, tiempo y lugar que señale "EL INSTITUTO", debiendo rendir los informes que le soliciten en relación con los
                                            mismos.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA SEGUNDA.- RESCISIÓN DEL ACUERDO: Queda expresamente pactado que la falta de cumplimiento a
                                            cualquiera de las obligaciones que se pactan en el presente instrumento, y de aquellas otras que emanan de las Leyes, y
                                            que son consubstanciales a las obligaciones contratadas, dará motivo a la rescisión del presente acuerdo, y generará el
                                            pago de los daños y perjuicios que el incumplimiento cause a la parte que dé motivo a la rescisión, conforme a lo
                                            siguiente:
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            a) Si "EL PRESTADOR DE SERVICIOS" incumple cualquiera de sus obligaciones contractuales;
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            b) Por prestar los servicios deficientemente, de manera inoportuna o por no apegarse a lo estipulado en el
                                            presente acuerdo;
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            c) Por no observar la discreción debida respecto de la información a la que tenga acceso como consecuencia
                                            de la prestación de los servicios encomendados;
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            d) Por suspender injustificadamente la prestación de los servicios o por negarse a corregir los rechazado por el
                                            "INSTITUTO";
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            e) Por negarse a presentar los informes al servidor público en los términos señalados del presente instrumento
                                            sobre la prestación y/o resultado de los servicios encomendados;
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            f) Se presente a cumplir con el presente acuerdo, en estado de ebriedad y/o el efecto de un enervante;
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            g) Por no observar el Código de Ética de las personas servidoras públicas del Gobierno Federal, así como el
                                            Código de Conducta del Tecnológico Nacional de México; y
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            h) Si "EL INSTITUTO" no realiza el pago de acuerdo a lo estipulado en la cláusula cuarta.
                                        </div>
                                    </v-col>
                                    <v-col cols="11">
                                        <div>
                                            i) Cuando las diversas disposiciones aplicables así lo señalen.
                                        </div>
                                    </v-col>

                                    <v-col cols="12">
                                        <div>
                                            Para los efectos de esta Cláusula, el "EL INSTITUTO" notificará por escrito a el "EL PRESTADOR DE SERVICIOS", el
                                            incumplimiento en que ésta haya incurrido, para que en un término de 03 (tres) días hábiles, exponga lo que su derecho
                                            convenga, y aporte, en su caso, las pruebas correspondientes.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            Transcurrido el término señalado en el párrafo anterior, el "EL INSTITUTO" a través de su Director, tomando en cuenta los
                                            argumentos y las pruebas ofrecidas por el "EL PRESTADOR DE SERVICIOS", determinarán de manera fundada y
                                            motivada si resulta procedente o no rescindir el acuerdo, y comunicará por escrito a el "EL PRESTADOR DE SERVICIOS"
                                            dicha determinación.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA TERCERA.- TERMINACIÓN ANTICIPADA: "EL INSTITUTO" en cualquier momento podrá dar por terminado
                                            anticipadamente el presente acuerdo sin responsabilidad para la Institución y sin necesidad de que medie resolución
                                            judicial alguna, dando aviso por escrito a "EL PRESTADOR DE SERVICIOS" con 03 (tres) días naturales de anticipación;
                                            así mismo, "EL PRESTADOR DE SERVICIOS" podrá darlo por concluido de manera anticipada, previo aviso a "EL
                                            INSTITUTO" efectuado en un lapso idéntico al señalado en líneas anteriores, y éste determinará lo conducente respecto a
                                            consentir en la terminación o deducir en su caso, las acciones legales que correspondan.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA CUARTA.- VINCULACIÓN LABORAL: "EL PRESTADOR DE SERVICIOS" conviene que todas las personas que
                                            tenga a su disposición para la prestación de los servicios objeto de este acuerdo, dependerán exclusivamente de éste, las
                                            cuales no tendrán ningún vínculo de orden laboral o de otra naturaleza con "EL INSTITUTO", por tanto "EL PRESTADOR
                                            DE SERVICIOS", será el único responsable de la ejecución de los servicios contratados, y en caso de que se llegase a
                                            presentar alguna reclamación imputable a "EL PRESTADOR DE SERVICIOS", éste se obliga a sacar en paz y a salvo a
                                            "EL INSTITUTO".
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA QUINTA.- RESPONSABILIDAD EN CASO FORTUITO O POR FUERZA MAYOR: "EL PRESTADOR DE
                                            SERVICIOS" no será responsable del cumplimiento de las obligaciones emanadas del presente acuerdo, en el supuesto
                                            de verse imposibilitado para cumplirlas parcial o totalmente, si se presentan eventos por caso fortuito o fuerza mayor,
                                            siempre que éstos estén debidamente documentados y sustentados.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            Cuando en la prestación del servicio se presente caso fortuito o de fuerza mayor, "EL INSTITUTO" bajo su responsabilidad podrá suspender la prestación del servicio, en cuyo caso, únicamente se pagarán aquéllos que hubiesen
                                            sido efectivamente prestados.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA SEXTA.- OBLIGACIONES FISCALES. "EL PRESTADOR DE SERVICIOS" se obliga a pagar el impuesto sobre
                                            la renta, de acuerdo con lo que dispone al Capítulo II, Articulo 106, de la Ley del Impuesto Sobre la Renta. Así mismo, "EL
                                            INSTITUTO" enterará las cantidades retenidas por concepto de IVA e ISR al Servicio de Administración Tributaria de la
                                            Secretaría de Hacienda y Crédito Público a través del Tecnológico Nacional de México.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA SÉPTIMA.- OBLIGACIONES DEL PRESTADOR DE SERVICIOS CON TERCEROS. Este acuerdo se suscribe
                                            en atención a que "EL PRESTADOR DE SERVICIOS" cuenta con los recursos necesarios para ejecutar los servicios
                                            personales independientes requeridos y, por lo tanto, en ningún momento se considera como intermediario de "EL
                                            INSTITUTO" en cuanto al personal que, en su caso llegare a ocupar, y la exime de cualquier responsabilidad laboral, de
                                            seguridad social, civil, fiscal o de otra índole que a este respecto existiera.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            El "EL PRESTADOR DE SERVICIOS" no podrá ceder en forma parcial ni total el favor de cualquier otra persona física o
                                            moral, los derechos y obligaciones derivadas del presente acuerdo.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA OCTAVA.- PROPIEDAD Y CONFIDENCIALIDAD DE LOS TRABAJOS. "EL PRESTADOR DE SERVICIOS" se
                                            obliga a que por ningún motivo podrá divulgar los informes, datos y resultados obtenidos que provengan de los servicios
                                            objeto del presente acuerdo, ya que la misma es confidencial y propiedad de "EL INSTITUTO".
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            La titularidad de los derechos patrimoniales que se originen con ejecución de las actividades y/o trabajos objeto del
                                            presente acuerdo, corresponderá al "EL INSTITUTO", dando el debido reconocimiento por su participación a el "EL
                                            PRESTADOR DE SERVICIOS", como colaborador remunerado, quien en términos del artículo 83, párrafo segundo de la
                                            Ley Federal del Derecho de Autor, tendrá el derecho a que se le menciona expresamente su calidad de autor, artista,
                                            intérprete o ejecutante sobre la parte o partes en cuya creación haya participado.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            Asimismo, si como resultado de las actividades desarrolladas con motivo del presente acuerdo, se genera algún derecho
                                            de propiedad industrial (como patentes, marcas, diseños industriales, etc.) el "EL PRESTADOR DE SERVICIOS"
                                            reconoce en este acto, que la titularidad de dicho derecho corresponderá al "EL INSTITUTO".
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            DÉCIMA NOVENA.- JURISDICCIÓN. "LAS PARTES" convienen en someterse, para todo lo no previsto en este acuerdo,
                                            a las disposiciones del Capítulo II, del Título Décimo, Parte Segunda, Libro Cuarto y demás relativos del Código Civil
                                            Federal, por no ser aplicable la Ley Federal del Trabajo en los términos previstos por su artículo uno, ni la Ley Federal de
                                            los Trabajadores al Servicio del Estado.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div>
                                            VIGÉSIMA PRIMERA.- INTERPRETACIÓN. Para la interpretación y cumplimiento del presente acuerdo, y para todo
                                            aquello que no esté expresamente estipulado en el mismo, las partes se someten a la jurisdicción de los Tribunales
                                            Federales de la ciudad de México, Distrito Federal, por lo tanto "EL PRESTADOR DE SERVICIOS" renuncia al fuero que
                                            pudiera corresponderle por razón de su domicilio presente o futuro.
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            VIGÉSIMA SEGUNDA.- CONSENTIMIENTO: "LAS PARTES" manifiestan que en la confección del presente acuerdo han
                                            emitido libremente su voluntad, sin que medie error, dolo, lesión, violencia o mala fe que lo invalide, conociendo sus
                                            alcances y efectos legales, otorgan su consentimiento para celebrarlo y cumplirlo en todas y cada una de sus partes y
                                        </div>
                                        <div class="d-flex">
                                            enteradas del contenido y fuerza legal, lo firman al margen y al calce en todas sus fojas útiles en la ciudad de
                                            <v-text-field class="nombrepersonal mx-2 accent" v-model="ciudad" dense hide-details></v-text-field>
                                            , a los
                                            <v-text-field class="fecha mx-2 accent" v-model='fecha' dense hide-details></v-text-field>.
                                        </div>
                                    </v-col>
                                </v-row>


                                <v-row class="d-flex justify-center">
                                    <v-col cols="12">
                                        <div class="d-flex justify-center">
                                            <v-spacer></v-spacer>
                                            <span><b>"EL INSTITUTO"</b></span>
                                            <v-spacer></v-spacer>
                                            <span><b>"EL PRESTADOR DE SERVICIOS"</b></span>
                                            <v-spacer></v-spacer>
                                        </div>
                                        <br><br><br>
                                        <div class="d-flex justify-center">
                                            <v-spacer></v-spacer>
                                            <span><b>__________________________</b></span>
                                            <v-spacer></v-spacer>
                                            <span><b>__________________________</b></span>
                                            <v-spacer></v-spacer>
                                        </div>
                                        <div class="d-flex justify-center">
                                            <v-spacer></v-spacer>
                                            <span><b>{{representante}}</b></span>
                                            <v-spacer></v-spacer>
                                            <span><b>{{psp_seleccionado.nombre}}</b></span>
                                            <v-spacer></v-spacer>
                                        </div>
                                        <br><br><br><br>
                                        <div class="d-flex justify-center">
                                            <v-spacer></v-spacer>
                                            <span><b>"TESTIGO"</b></span>
                                            <v-spacer></v-spacer>
                                            <span><b>"TESTIGO"</b></span>
                                            <v-spacer></v-spacer>
                                        </div>
                                        <br><br><br>
                                        <div class="d-flex justify-center">
                                            <v-spacer></v-spacer>
                                            <span><b>__________________________</b></span>
                                            <v-spacer></v-spacer>
                                            <span><b>__________________________</b></span>
                                            <v-spacer></v-spacer>
                                        </div>
                                        <div class="d-flex justify-center">
                                            <v-spacer></v-spacer>
                                            <span> <v-text-field class="nombrepersonal mx-2 accent" v-model="testigo1" hide-details outlined dense></v-text-field> </span>
                                            <v-spacer></v-spacer>
                                            <span> <v-text-field class="nombrepersonal mx-2 accent" v-model="testigo2" hide-details outlined dense></v-text-field> </span>
                                            <v-spacer></v-spacer>
                                        </div>


                                        <p>
                                            Estas firmas corresponden al acuerdo de Prestación de Servicios Profesionales bajo el régimen de Honorarios con base al
                                            acuerdo {{folio}}, suscrito entre el
                                            <b>Instituto Tecnológico de Parral</b> y <b>{{psp_seleccionado.nombre}}</b>
                                            , en la Ciudad de {{ciudad}}, a los {{fecha}}.
                                        </p>
                                    </v-col>
                                </v-row>

                            </div>

                            <v-row class="d-flex justify-center">
                                <v-col cols="12" sm="12" class="d-flex justify-end">
                                    <v-btn v-if="btn_guardar && modo_pantalla == 'crear' " @click="crearContrato()" color="primary" class="mr-4" :loading='creando_contrato' dark>Guardar</v-btn>
                                    <v-btn v-if="btn_guardar_cambios || modo_pantalla == 'modificar' " @click="guardarCambios()" color="primary" class="mr-4" :loading='creando_contrato' dark>Guardar cambios</v-btn>
                                    <v-btn v-if='btn_borrador || modo_pantalla =="modificar" ' @click="imprimirContrato(idcontratocreado, 1)" color="secondary" class="mr-4" dark>Imprimir Borrador</v-btn>
                                    <v-btn v-if='btn_firmar || modo_pantalla =="modificar" ' @click="firmarContrato(idcontratocreado)" color="success" class="mr-4" dark>Firmar</v-btn>
                                    <v-btn @click="cerrarDialogoContrato()" color="error" class="mr-4" dark>Cerrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-dialog>

            <!-- </div> -->

            <v-dialog v-model="cargando" v-if="cargando" max-width="300" persistent>
                <v-card>
                    <v-card-text class="d-flex justify-center">
                        <b class="mt-5">Consultando información</b>
                    </v-card-text>
                    <v-card-text>
                        <v-progress-linear indeterminate color="success"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="snackbar" :color="snackbarcolor" light >
                <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
            </v-snackbar>

            <dialogoconfirmacion ref="dialogoconfirmacion"></dialogoconfirmacion>
        </v-container>
    </div>
</template>

<script>

import menulateral from "@/components/MenuLateralAdmin";
import barraprincipaladmin from "@/components/BarraPrincipalAdmin";
import dialogoconfirmacion from '@/components/DialogoConfirmacion'
const numeral = require('numeral')

export default {

    components:{
        menulateral,
        barraprincipaladmin,
        dialogoconfirmacion,
    },

    data() {
        return {
            modo_pantalla: 'crear',

            select_servicio: false,
            btn_guardar: true,
            btn_guardar_cambios: false,
            btn_borrador: false,
            btn_firmar: false,

            menu_visible: false,
            dlgcontrato: false,

            snackbartexto: "",
            snackbar: false,
            snackbarcolor: "",

            busqueda:'',
            tabla_encabezado:[],
            contratos: [],
            page_text:'',
            cargando: true,
            color_fondo:"blue lighten-4",

            creando_contrato: false,
            idcontratocreado: 0,

            servicios_requeridos: [],
            servicio_seleccionado: [],
            servicio_detalle: null,
            prestadores_de_servicios: [],

            //Contrato
            folio: '',
            representante: 'José María Morales Sáenz',
            psp_seleccionado: [],
            nombramiento_oficios: '075',
            nombramiento_fecha: '14 de junio de 2019',
            nombramiento_emisor: 'Subsecretario de Educación Superior',
            psp_conocimientos: '',


            item_partida:[
                {
                    text:'12101 Honorarios',
                    value:{'clave':'12101 Honorarios', 'descripcion':'Asignaciones destinadas a cubir el pago por la prestación de servicios contratados con personas físicas, como profesionistas, técnicos, expertos y peritos, entre otros, por estudios, obras o trabajos determinados que correspondan a su especialidad'}
                },
                {
                    text:'13404 Compensaciones por servicios eventuales',
                    value:{'clave':'13404 Compensaciones por servicios eventuales', 'descripcion':'Asignaciones por servicios eventuales, suplencias, sustituciones, pagos a empleados, salientes por el tiempo que utilicen en la entrega del cargo o bien en el relevo del servicio cuando se encuentre justificada esta espera o por la liquidación de diferencias de sueldo, en los términos de las disposiciones que establezca la Secretaría a través de la Unidad de Politica y Control Presupuestario'}
                }
            ],

            partida: [],

            //partida: '12101 Honorarios',
            //partida_descripcion: 'Asignaciones destinadas a cubir el pago por la prestación de servicios contratados con personas físicas, como profesionistas, técnicos, expertos y peritos, entre otros, por estudios, obras o trabajos determinados que correspondan a su especialidad',

            circular_adjudicacion_folio: 'M00/014/2022',
            circular_adjudicacion_fecha: '24 de febrero de 2022',

            direccion_instituto: 'Avenida Tecnológico No. 57, C.P. 33850, Colonia Centro, Hidalgo del Parral, Chihuahua',
            direccion_prestacion_servicio: 'Avenida Tecnológico No. 57, C.P. 33850, Colonia Centro, Hidalgo del Parral, Chihuahua',

            psp_rfc: '',
            psp_curp: '',
            psp_banco: '',
            psp_sucursal: '',
            psp_cuenta: '',
            psp_clabe: '',
            psp_tarjeta: '',
            psp_direccion: '' ,
            psp_tipo_contrato: '',
            psp_es_resico: false,

            periodo_servicio: '',
            actividades: '',
            servicio_descripcion: '',

            area: '',
            dias: '',
            horario: '',
            horas: '',

            ejercicio_fiscal: new Date().getFullYear(),
            subtotal: 0.0,
            iva: 0.0,
            ret_iva: 0.0,
            ret_isr: 0.0,

            supervision: 'coordinador del programa',

            testigo1: 'Pedro Iván Sáenz Sotelo',
            testigo2: 'Jesús Daniel Hernández Camacho',

            ciudad: 'Hidalgo del Parral',
            fecha: '',
            lugar_fecha: '',

            

        }
    },

    beforeCreate() {
        const token = sessionStorage.getItem('datax')

        this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})
            .then((response)=>{

                const data = response.data

                if(data.codigo == 'lgout')
                    this.$router.push({"name":'AdminLogin'})

            })
            .catch((error)=>{
                console.log("Error "+error);
            })
    },

    created(){
        this.getContratos()
        this.getFechaLarga()
    },

    watch:{
        fecha(){
            this.lugar_fecha = this.ciudad + ' ' + this.fecha
        },

        psp_seleccionado(){
            this.psp_rfc = this.psp_seleccionado.rfc
            this.psp_curp =  this.psp_seleccionado.curp
            this.psp_banco = this.psp_seleccionado.banco
            this.psp_sucursal = this.psp_seleccionado.sucursal
            this.psp_cuenta = this.psp_seleccionado.cuenta
            this.psp_clabe = this.psp_seleccionado.clabe
            this.psp_tarjeta = this.psp_seleccionado.tarjeta
            this.psp_direccion = 'Calle '+this.psp_seleccionado.calle +' '+ this.psp_seleccionado.numero +', Colonia '+ this.psp_seleccionado.colonia +', '+ this.psp_seleccionado.ciudad
            this.psp_tipo_contrato = this.psp_seleccionado.tipo_contrato
            this.psp_es_resico = this.psp_seleccionado.es_resico
        },

        psp_tipo_contrato(){
            if(this.psp_tipo_contrato == 'honorarios'){
                this.partida = {
                    'clave':'12101 Honorarios', 
                    'descripcion':'Asignaciones destinadas a cubir el pago por la prestación de servicios contratados con personas físicas, como profesionistas, técnicos, expertos y peritos, entre otros, por estudios, obras o trabajos determinados que correspondan a su especialidad'
                }
            }
            if(this.psp_tipo_contrato == 'asimilados'){
                this.partida ={
                    'clave':'13404 Compensaciones por servicios eventuales', 
                    'descripcion':'Asignaciones por servicios eventuales, suplencias, sustituciones, pagos a empleados, salientes por el tiempo que utilicen en la entrega del cargo o bien en el relevo del servicio cuando se encuentre justificada esta espera o por la liquidación de diferencias de sueldo, en los términos de las disposiciones que establezca la Secretaría a través de la Unidad de Politica y Control Presupuestario'
                }
            }
        },



        servicio_seleccionado(){           
            this.periodo_servicio = this.servicio_seleccionado.periodo
            this.actividades = this.servicio_seleccionado.actividades
            this.servicio_descripcion = this.servicio_seleccionado.descripcion
            this.area = this.servicio_seleccionado.area
            this.dias = this.servicio_seleccionado.dias
            this.horario = this.servicio_seleccionado.horario
            this.horas = this.servicio_seleccionado.horas
        }
    },

    computed: {
        montotal(){
            if(this.servicio_detalle != null){
                let total = 0.0

                if(this.modo_pantalla == 'crear'){
                    for(let act of this.servicio_detalle.actividades){
                        if(this.psp_tipo_contrato == 'honorarios')
                            total += act.subtotal + act.iva
                        if(this.psp_tipo_contrato == 'asimilados')
                            total += act.subtotal
                    }
                }
                if(this.modo_pantalla == 'modificar'){
                    if(this.psp_tipo_contrato == 'honorarios')                   
                        total = this.subtotal + this.iva  
                    if(this.psp_tipo_contrato == 'asimilados')            
                        total = this.subtotal
                }                
                return numeral(total).format('0.00')
            }else{
                return 0.0
            }        
        },

        cp_subtotal(){
            if(this.servicio_detalle != null){
                let total = 0.0

                for(let act of this.servicio_detalle.actividades){
                    total += act.subtotal
                }

                return total
            }else{
                return 0.0
            }        
        },
        
        cp_iva(){
            if(this.servicio_detalle != null){
                let total = 0.0

                for(let act of this.servicio_detalle.actividades){
                    total += act.iva
                }

                return total
            }else{
                return 0.0
            }     
        },

        cp_ivaretenido(){
            if(this.servicio_detalle != null){
                let total = 0.0

                for(let act of this.servicio_detalle.actividades){
                    total += act.iva_retenido
                }

                return total
            }else{
                return 0.0
            }     
        },

        cp_isrretenido(){
            if(this.servicio_detalle != null){
                let total = 0.0

                for(let act of this.servicio_detalle.actividades){
                    total += act.isr_retenido
                }

                return total
            }else{
                return 0.0
            }     
        }



    },

    methods: {
        mtMenuVisible(value){
            this.menu_visible = value
        },

        texto_paginacion: function(pg){
            this.page_text = 'Total elementos '+pg.itemsLength
        },

        getContratos(){
            const token = sessionStorage.getItem('datax')

            this.cargando = true
            this.contratos = []
            this.axios.get(this.$url+'/admin/contratos/listado', {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error){
                        //Encabezados de la tabla
                        this.tabla_encabezado = []
                        for(let key in data.contratos[0])
                            if(key == 'contrato' || key == 'prestador_de_servicios' || key == 'partida' || key == 'subtotal' || key == 'iva' || key == 'iva_ret' || key == 'isr_ret' || key == 'monto' || key == 'fecha_alt' || key == 'estado')
                                this.tabla_encabezado.push({
                                    text:key.toUpperCase(),
                                    value:key,
                                    class:"black--text"
                                })

                        //Agrego la columna de acciones a la tabla
                        this.tabla_encabezado.push({
                            text:"ACCIONES",
                            value:"acciones",
                            class:"black--text"
                        })

                        this.contratos = data.contratos
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }
                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        getDetalleContrato(item){

            this.modo_pantalla = 'modificar'
            this.select_servicio = true

            const token = sessionStorage.getItem('datax')

            this.cargando = true
            this.axios.get(this.$url+'/admin/contratos/detalle/'+item.ccontrato, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    const dc = data.detallecontrato

                    if(!data.error){

                        // //Contrato
                        this.folio = dc.contrato
                        this.representante = dc.representante
                        // //psp_seleccionado: [],
                        this.nombramiento_oficios = dc.nombramiento_oficios
                        this.nombramiento_fecha = dc.nombramiento_fecha
                        this.nombramiento_emisor = dc.nombramiento_emisor
                        this.psp_conocimientos = dc.psp_conocimientos
                        
                        //this.partida = dc.partida
                        //this.partida_descripcion = dc.partida_descripcion
                        this.partida = {'clave':dc.partida, 'descripcion':dc.partida_descripcion}

                        this.circular_adjudicacion_folio = dc.circular_adjudicacion_folio
                        this.circular_adjudicacion_fecha = dc.circular_adjudicacion_fecha
                        this.direccion_instituto = dc.direccion_instituto
                        this.direccion_prestacion_servicio = dc.direccion_prestacion_servicio
                        this.periodo_servicio = dc.periodo
                        this.actividades = dc.actividades
                        this.servicio_descripcion = dc.servicio_descripcion                        
                        this.ejercicio_fiscal = dc.ejercicio_fiscal
                        this.subtotal = parseFloat(dc.subtotal)
                        this.iva = parseFloat(dc.iva)
                        this.ret_iva = parseFloat(dc.ret_iva)
                        this.ret_isr = parseFloat(dc.ret_isr)
                        this.lugar_fecha = dc.lugar_fecha
                        this.ciudad = dc.lugar
                        this.fecha = dc.fecha
                        this.testigo1 = dc.testigo1
                        this.testigo2 = dc.testigo2
                        this.supervision = dc.supervision

                      //  this.psp_tipo_contrato = dc.tipo_contrato
                       // this.psp_es_resico = dc.tipo_contrato

                        this.idcontratocreado = item.ccontrato
                        this.dlgcontrato = true

                        this.servicios_requeridos = [{"value": dc.cservicio, "text": dc.servicio_descripcion}]
                        this.servicio_seleccionado = dc.cservicio

                        this.getDetalleServicio(dc.cservicio)

                        //Llamo al metodo que trae los psp activos, espero que termine y seteo el que tiene el contrato
                        this.getPrestadoresDeServicios()
                            .then(()=>{
                                for(let el of this.prestadores_de_servicios){
                                    if(dc.cprestador == el.value.id){
                                        this.psp_seleccionado = el.value
                                        break
                                    }
                                }
                            })

                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        abrirDialogoContrato(){   
            this.modo_pantalla = 'crear'         
            this.getServicios()
            this.getPrestadoresDeServicios()
            this.select_servicio =false,
            this.btn_guardar = true,
            this.btn_guardar_cambios = false
            this.dlgcontrato = true
            this.btn_borrador = false
            this.btn_firmar = false
        },

        cerrarDialogoContrato(){
            this.dlgcontrato = false
            this.limpiaDatosContrato()
        },

        getServicios(){
            const token = sessionStorage.getItem('datax')

            this.cargando = true
            this.servicios_requeridos = []
            this.axios.get(this.$url+'/admin/serviciosrequeridos/listadosimple/1', {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error){
                        data.servicios.forEach(elm => {
                            this.servicios_requeridos.push({text:elm.descripcion, value: elm.id})
                        });
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        getDetalleServicio(item){

            const token = sessionStorage.getItem('datax')

            this.cargando = true
            this.servicio_detalle = null
            this.axios.get(this.$url+'/admin/serviciosrequeridos/detalle/'+item, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error){
                        this.servicio_detalle = data.serviciodetalle
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },


        getPrestadoresDeServicios(){
            const token = sessionStorage.getItem('datax')

            return new Promise((resolve, reject)=>{
                this.cargando = true
                this.axios.get(this.$url+'/admin/psp/listadoactivos', {headers: {Authorization:`Bearer ${token}`}})
                    .then((response)=>{
                        const data = response.data

                        if(!data.error){
                            this.prestadores_de_servicios = []

                            data.prestadores.forEach(elm => {
                                this.prestadores_de_servicios.push({text: elm.nombre, value: elm})
                            });

                            resolve()
                        }
                        else{
                            this.snackbartexto = data.mensaje
                            this.snackbarcolor = 'red'
                            this.snackbar = true

                            reject()
                        }

                    })
                    .catch((error)=>{
                        console.log("Ocurrio un error "+error);
                        reject()
                    })
                    .finally(()=>{
                        this.cargando = false
                    })
             })
        },

        getFechaLarga(){
            this.cargando = true
            this.axios.get(this.$url+'/fechas/fechalarga')
                .then((response)=>{
                    const data = response.data
                    
                    this.fecha = data.fechalarga

                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        crearContrato(){          

            if(this.folio == ''){
                this.snackbartexto = 'Folio de contrato requerido.'
                this.snackbarcolor = 'red'
                this.snackbar = true
                return
            }

            if(this.servicios_requeridos.length == 0){
                this.snackbartexto = 'Seleccione un servicio para ligar a este contrato.'
                this.snackbarcolor = 'red'
                this.snackbar = true
                return
            }

            if(this.servicio_detalle == null){
                this.snackbartexto = 'Seleccione un servicio para ligar a este contrato.'
                this.snackbarcolor = 'red'
                this.snackbar = true
                return
            }

            if(this.psp_seleccionado.length == 0){
                console.log(this.psp_seleccionado);
                this.snackbartexto = 'Seleccione un prestador de servicios para ligar a este contrato.'
                this.snackbarcolor = 'red'
                this.snackbar = true
                return
            }


            const token = sessionStorage.getItem('datax')

            const datos = {
                id_servicio: this.servicio_seleccionado,
                id_psp: this.psp_seleccionado.id,
                folio_contrato: this.folio,
                representante: this.representante,
                prestador_servicios: this.psp_seleccionado.nombre,
                nombramiento_oficios: this.nombramiento_oficios,
                nombramiento_fecha: this.nombramiento_fecha,
                nombramiento_emisor: this.nombramiento_emisor,
                psp_conocimientos: this.servicio_detalle.pspconocimientos,                
                //partida: this.partida,
                //partida_descripcion: this.partida_descripcion,
                partida: this.partida.clave,
                partida_descripcion: this.partida.descripcion,
                circular_adjudicacion_folio: this.circular_adjudicacion_folio,
                circular_adjudicacion_fecha: this.circular_adjudicacion_fecha,
                direccion_instituto: this.direccion_instituto,
                direccion_prestacion_servicio: this.direccion_prestacion_servicio,
                psp_rfc: this.psp_rfc,
                psp_curp: this.psp_curp,
                psp_banco: this.psp_banco,
                psp_sucursal: this.psp_sucursal,
                psp_cuenta: this.psp_cuenta,
                psp_clabe: this.psp_clabe,
                psp_tarjeta: this.psp_tarjeta,
                psp_direccion: this.psp_direccion,
                ejercicio_fiscal: this.ejercicio_fiscal,
                subtotal: this.cp_subtotal,
                iva: this.cp_iva,
                ret_iva: this.cp_ivaretenido,
                ret_isr: this.cp_isrretenido,
                lugar_fecha: this.lugar_fecha,
                lugar: this.ciudad,
                fecha: this.fecha,
                testigo1: this.testigo1,
                testigo2: this.testigo2,
                supervision: this.supervision,
                psp_tipo_contrato: this.psp_tipo_contrato,
                psp_es_resico: this.psp_es_resico
            }

            this.creando_contrato = true
            this.axios.post(this.$url+'/admin/contratos/crear', {datos:datos}, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{

                    let data = response.data

                    if(!data.error){
                        this.idcontratocreado = data.idcreado
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'green'
                        this.snackbar = true
                        this.select_servicio = true
                        this.btn_guardar = false
                        this.btn_guardar_cambios = true
                        this.btn_borrador = true                        
                        this.btn_firmar = true                        
                        this.getContratos()                        
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }

                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.creando_contrato = false
                })

        },

        guardarCambios(){
            
            if(this.servicios_requeridos == []){
                this.snackbartexto = 'Seleccione un servicio para ligar a este contrato.'
                this.snackbarcolor = 'red'
                this.snackbar = true
                return
            }

            if(this.servicio_detalle == null){
                this.snackbartexto = 'Seleccione un servicio para ligar a este contrato.'
                this.snackbarcolor = 'red'
                this.snackbar = true
                return
            }

            if(this.psp_seleccionado == []){
                this.snackbartexto = 'Seleccione un prestador de servicios para ligar a este contrato.'
                this.snackbarcolor = 'red'
                this.snackbar = true
                return
            }


            const token = sessionStorage.getItem('datax')

            const datos = {
                id_contrato: this.idcontratocreado,
                id_servicio: this.servicio_seleccionado,
                id_psp: this.psp_seleccionado.id,
                folio_contrato: this.folio,
                representante: this.representante,
                prestador_servicios: this.psp_seleccionado.nombre,
                nombramiento_oficios: this.nombramiento_oficios,
                nombramiento_fecha: this.nombramiento_fecha,
                nombramiento_emisor: this.nombramiento_emisor,
                psp_conocimientos: this.servicio_detalle.pspconocimientos,
                //partida: this.partida,
                //partida_descripcion: this.partida_descripcion,
                partida: this.partida.clave,
                partida_descripcion: this.partida.descripcion,
                circular_adjudicacion_folio: this.circular_adjudicacion_folio,
                circular_adjudicacion_fecha: this.circular_adjudicacion_fecha,
                direccion_instituto: this.direccion_instituto,
                direccion_prestacion_servicio: this.direccion_prestacion_servicio,
                psp_rfc: this.psp_rfc,
                psp_curp: this.psp_curp,
                psp_banco: this.psp_banco,
                psp_sucursal: this.psp_sucursal,
                psp_cuenta: this.psp_cuenta,
                psp_clabe: this.psp_clabe,
                psp_tarjeta: this.psp_tarjeta,
                psp_direccion: this.psp_direccion,
                ejercicio_fiscal: this.ejercicio_fiscal,
                subtotal: this.cp_subtotal,
                iva: this.cp_iva,
                ret_iva: this.cp_ivaretenido,
                ret_isr: this.cp_isrretenido,
                lugar_fecha: this.lugar_fecha,
                lugar: this.ciudad,
                fecha: this.fecha,
                testigo1: this.testigo1,
                testigo2: this.testigo2,
                supervision: this.supervision,
                psp_tipo_contrato: this.psp_tipo_contrato,
                psp_es_resico: this.psp_es_resico
            }

            this.creando_contrato = true
            this.axios.put(this.$url+'/admin/contratos/actualizar', datos, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{

                    let data = response.data

                    if(!data.error){                                                
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'green'
                        this.snackbar = true   
                        this.getContratos()                                                                                                                     
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }

                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.creando_contrato = false
                })
        },

        imprimirContrato(idcontrato, estatus){

            let tipo = 'B'
            if(estatus == 1)
                tipo = 'B'
            if(estatus == 2)
                tipo = 'F'
            

            const token = sessionStorage.getItem('datax')
            this.cargando = true
            this.axios.get(this.$url+'/admin/contratos/pdfcontrato/'+idcontrato+'/'+tipo,
                    {
                        headers: {Authorization:`Bearer ${token}`},
                        responseType: 'blob'
                    })
                .then((response)=>{
                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                    
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)
                })
                .catch((error)=>{
                    console.log(error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        async firmarContrato(ccontrato){

            
            const confirma = await this.$refs.dialogoconfirmacion.abrir({
                titulo: 'Al firmar el contrato no podrá realizar cambios ¿desea continuar?',
                confirmar: 'Si',
                cancelar: 'No'
            })

            if(!confirma){
                return
            }



            const token = sessionStorage.getItem('datax')

            const datos = {
                ccontrato: ccontrato                
            }

            this.cargando = true
            this.axios.post(this.$url+'/admin/contratos/firmar', {datos:datos}, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{

                    let data = response.data

                    if(!data.error){                        
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'green'
                        this.snackbar = true
                        this.getContratos()                        
                        this.imprimirContrato(this.idcontratocreado, 2)
                        this.cerrarDialogoContrato()
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }

                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        async eliminarContrato(item){

            const confirma = await this.$refs.dialogoconfirmacion.abrir({
                titulo: '¿Realmente quiere eliminar el contrato?',
                confirmar: 'Si',
                cancelar: 'No'
            })

            if(!confirma){
                return
            }


            
            const token = sessionStorage.getItem('datax')

            const datos = {
                ccontrato: item.ccontrato,
                cservicio: item.cservicio
            }

            this.cargando = true
            this.axios.post(this.$url+'/admin/contratos/eliminar', {datos:datos}, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{

                    let data = response.data

                    if(!data.error){                        
                        this.idcontratocreado = data.idcreado
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'green'
                        this.snackbar = true
                        this.getContratos()
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }

                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        limpiaDatosContrato(){
            
            this.servicios_requeridos = []            
            this.servicio_seleccionado = []
            this.partida = []
            this.servicio_detalle = null,
            this.prestadores_de_servicios = [],

            //Contrato
            this.folio = ''            
            this.psp_seleccionado = [],            
            this.psp_conocimientos = '',   

            this.psp_rfc = '',
            this.psp_curp = '',
            this.psp_banco = '',
            this.psp_sucursal = '',
            this.psp_cuenta = '',
            this.psp_clabe = '',
            this.psp_tarjeta = '',
            this.psp_direccion ='' ,
            this.psp_tipo_contrato = '',
            this.psp_es_resico = false,

            this.periodo_servicio = '',
            this.actividades = '',
            this.servicio_descripcion = ''          

        }

    },
}
</script>


<style>
    .contrato{
        font-size: 16px;
        color: black;
        margin-block-start: 10px;
        margin-block-end: 10px;
        padding-left: 5px;
        padding-right: 5px;
    }
    .nombrepersonal{
        max-width: 350px !important;
    }
    .oficio{
        max-width: 100px !important;
    }
    .fecha{
        max-width: 230px !important;
    }
    .partida{
        max-width: 200px !important;
    }
    .circular{
        max-width: 140px !important;
    }
    .rfc{
        max-width: 300px !important;
    }
    .anio{
        max-width: 79px !important;
    }

</style>
